/** @format */

/**
 * 判断是否是长城环境
 *
 */
export const isChangcheng: boolean = 'changcheng'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
/**
 * 判断是否是时代邻里环境
 *
 */
export const isShiDaill: boolean = 'shidaill,shidailluat,shidaillsit'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
/**
 * 判断是否是时代商业环境
 *
 */
export const isShiDaisy: boolean = 'testing,sdshangye,release,development'.includes(
  window.VUE_APP_SERVER_CONFIG.APP_ENV
);
/**
 * 判断是否是文旅环境
 *
 */
export const isWenlv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
/**
 * 判断是否是中天
 *
 */
export const isZhongtian: boolean = 'zhongtian'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
/**
 * 判断是否是金华
 *
 */
export const isJinHua: boolean = 'jinhua'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
/**
 * 判断是否是新希望
 */
export const isNewHope: boolean = 'newhope,newhopetest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
